// src/com/trans_plan_result/TransPlanResultView.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle, AppWord, TopCode } from '../../value/AppConst';
import { Button, Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { LabelCell, ViewerCloserBox } from '../../common/TopStyle';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { useAuthorizationCheck } from '../../api/app-hook';

const DetailBox = styled(Box)({
    marginTop: '0.5rem', paddingBottom: '0.5rem',
    borderBottom: '1px solid #ccc',
    //borderRadius: '0.5rem',
    backgroundColor: '#fff',
});

const DetailHeader = styled(Box)({
    backgroundColor: '#eee', color: AppStyle.PrimaryRGB, // padding: '0.5rem',
    border: '1px solid #ddd', padding: '0.5rem',
    borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
});

/**
 * 용차시간관리 상세정보.
 */
export default function TransPlanResultView({
    item,
    onClose,
    onRequestReportInOut,
    loading
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();
    const canSave = checkAuth(authTableTree.tree.pr_trans_plan_result_report);

    const onClickSetDcDptrTime = () => {
        if(window.confirm('DC 출발시각을 설정하시겠습니까?')) {
            onRequestReportInOut({
                planId: item.planId,
                eventId: TopCode.IrAction.DC_DEP
            });
        }
    };

    const onClickSetStoreArrTime = () => {
        if(window.confirm('점포 도착시각을 설정하시겠습니까?')) {
            onRequestReportInOut({
                planId: item.planId,
                eventId: TopCode.IrAction.STORE_ARR
            });
        }
    };

    return(
        <DetailBox>
            <DetailHeader>
                <span>{item.dcName}</span>
                <span style={{marginLeft: '1rem', marginRight: '1rem'}}>...</span>
                <span>{item.storeName}</span>
            </DetailHeader>
            <TableContainer component={Paper}>
                <Table size={AppWord.SMALL}>
                    <TableBody>
                        <TableRow>
                            <LabelCell>출발지</LabelCell>
                            <TableCell>{item.dcName}</TableCell>
                            <LabelCell>도착지</LabelCell>
                            <TableCell>{item.storeName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>운송사</LabelCell>
                            <TableCell colSpan={3}>{item.comName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>기사명</LabelCell>
                            <TableCell>{item.driverName}</TableCell>
                            <LabelCell>기사전화</LabelCell>
                            <TableCell>
                                {
                                    item.driverMobile && item.driverMobile.length > 9 ?
                                    <a href={`tel:${item.driverMobile}`}>
                                    {item.driverMobile}
                                    </a>
                                    : '(없음)'
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>DC 출발</LabelCell>
                            <TableCell colSpan={3}>{item.dcKeyDptrTime}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>점포 도착</LabelCell>
                            <TableCell colSpan={3}>{item.storeKeyArrTime}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Grid2 container spacing={3} style={{margin: '0.5rem'}}>
                    <Grid2 item size={6}>
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                            disabled={!canSave || loading}
                            onClick={onClickSetDcDptrTime}
                            fullWidth
                        >
                            DC 출발시각 설정
                        </Button>
                    </Grid2>
                    <Grid2 item size={6}>
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                            disabled={!canSave || loading}
                            onClick={onClickSetStoreArrTime}
                            fullWidth
                        >
                            점포 도착시각 설정
                        </Button>
                    </Grid2>
                </Grid2>
            </TableContainer>
            <ViewerCloserBox onClick={onClose} />
        </DetailBox>
    );
}
